import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { GroupDescriptor } from "@progress/kendo-data-query";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { PagingDataResult, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { BehaviorSubject, Observable } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AccCloseProfitandLossAccountsDetail } from "../../models/acc-close-profitand-loss-accounts-detail.model";
import { AccCloseProfitandLossAccountsHeader } from "../../models/acc-close-profitand-loss-accounts-header.model";
import { AccVoucherKind } from "../../models/accvoucherkind.model";
import { SubLedger } from "../../models/subledger.model";
import { VoucherInfo } from "../../models/voucherInfo.model";

@Component({
  selector: "ngx-acc-close-profitand-loss-accounts-form",
  templateUrl: "./acc-close-profitand-loss-accounts-form.component.html",
  styleUrls: ["./acc-close-profitand-loss-accounts-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccCloseProfitandLossAccountsFormComponent extends BaseFormComponent<AccCloseProfitandLossAccountsHeader> {
  activeTabTitle: string;
  UnSelectAccounts: AccCloseProfitandLossAccountsDetail[] = [];
  _UnSelectAccounts: AccCloseProfitandLossAccountsDetail[] = [];
  isLoading: boolean;
  RowForSelect: AccCloseProfitandLossAccountsDetail;
  RowForDelete: AccCloseProfitandLossAccountsDetail;
  DefaultValues: Dictionary = [];
  AccCloseProfitandLossAccountsDetails: form_control[];
  AccCloseProfitandLossAccountsDetailsList: AccCloseProfitandLossAccountsDetail[] = [];
  groups: GroupDescriptor[] = [{ field: "SubLedgerTitle" }];
  ColumnsName: string = "Code,Title";
  erroremessage: String;
  PrevSubLedgerId: number;
  LookupIsLoading: Dictionary = [];
  currentSubLedger: SubLedger;
  _detailLedgerLevel: number;
  constructor(
    private datatransfer: Datatransfer,
    private missetup: MisSetupService,
    protected cd: ChangeDetectorRef,
    protected selectorService: SelectorService,
    private splashFormService: SplashFormService,
    __id: FormContainerModel,
    _tabsservice: TabularService
  ) {
    super(selectorService, cd);
    this.currentrow = this.datatransfer?.currentrow;
    this.apiName = this.datatransfer?.apiName;
    this.label = this.datatransfer?.label;
    this.areaName = this.datatransfer?.areaName;
    this._id = __id;
    this.tabsservice = _tabsservice;
    this.shouldBeChangedData = this.shouldBeChangedData.bind(this);
    this.onDataStateChange = this.onDataStateChange.bind(this);
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.UnSelectAccounts = undefined;
    this.RowForSelect = undefined;
    this.RowForDelete = undefined;
    this.DefaultValues = undefined;
    this.groups = undefined;
    this.LookupIsLoading = undefined;
    this.currentSubLedger = undefined;
    this.AccCloseProfitandLossAccountsDetails = undefined;
  }
  async ngOnInit() {
    this.setAccVoucherKind();
    this.apiName = "AccCloseProfitandLossAccountsHeader";
    this.label = this.translate("ClientApp.BackOffice.ACC.AccCloseProfitandLossAccountsHeader.AccCloseProfitandLossAccountsHeader");
    super.ngOnInit();
  }
  setdefault() {
    if (!this.model.VoucherDate) this.model.VoucherDate = new Date();
    if (!this.model.AccCloseProfitandLossAccountsDetails) this.model.AccCloseProfitandLossAccountsDetails = [];
    this.DefaultValues["AccCloseProfitandLossAccountsHeaderId"] = 0;
    this.setDefaultValues();
    this.setColumnAttribute();
    this.getUnSelectAccounts();
    if (!this._detailLedgerLevel) this._detailLedgerLevel = this.missetup.getnumber("ACC", "DLLEVEL");
  }
  setColumnAttribute() {
    super.setColumnAttribute();
    this.orignalColumns.forEach((x) => {
      if (x.name.includes("SubLedgerId")) {
        x.formVisible = true;
        x.required = true;
      }
      if (x.name.includes("DetailLedgerId")) {
        x.formVisible = false;
        x.required = false;
      }
      if (x.name.includes("DetailLedger2Id")) {
        x.formVisible = false;
        x.required = false;
      }
      if (x.name.includes("DetailLedger3Id")) {
        x.formVisible = false;
        x.required = false;
      }
      if (x.name.includes("DetailLedger4Id")) {
        x.formVisible = false;
        x.required = false;
      }
      if (x.name.includes("DetailLedger5Id")) {
        x.formVisible = false;
        x.required = false;
      }
      if (x.name.includes("DetailLedger6Id")) {
        x.formVisible = false;
        x.required = false;
      }
      if (x.name.includes("DetailLedger7Id")) {
        x.formVisible = false;
        x.required = false;
      }
      x.disabled = this.model.AccVoucherHeaderId !== undefined && this.model.AccVoucherHeaderId !== null;
    });
    this.columns = this.orignalColumns.filter(
      (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
    );
    this.columns = this.columns.sort((a, b) => a.order - b.order);
    this.setColumnNumber(this.columns, 3);
    this.AccCloseProfitandLossAccountsDetails = this.getDetailControlModels("AccCloseProfitandLossAccountsDetails");

    this.columns.forEach((x) => (x.isFloat = null));
    this.cd.markForCheck();

  }
  addControl() {
    this.cd.markForCheck();
  }
  setRemainValue() {
    if (this.model.AccCloseProfitandLossAccountsDetails) {
      this.UnSelectAccounts.forEach((x) => {
        if (
          this.model.AccCloseProfitandLossAccountsDetails.some(
            (s) =>
              s.SubLedgerId === x.SubLedgerId &&
              s.DetailLedgerId === x.DetailLedgerId &&
              s.DetailLedger2Id === x.DetailLedger2Id &&
              s.DetailLedger3Id === x.DetailLedger3Id &&
              s.DetailLedger4Id === x.DetailLedger4Id &&
              s.DetailLedger5Id === x.DetailLedger5Id &&
              s.DetailLedger6Id === x.DetailLedger6Id &&
              s.DetailLedger7Id === x.DetailLedger7Id
          )
        )
          this.model.AccCloseProfitandLossAccountsDetails.find(
            (s) =>
              s.SubLedgerId === x.SubLedgerId &&
              s.DetailLedgerId === x.DetailLedgerId &&
              s.DetailLedger2Id === x.DetailLedger2Id &&
              s.DetailLedger3Id === x.DetailLedger3Id &&
              s.DetailLedger4Id === x.DetailLedger4Id &&
              s.DetailLedger5Id === x.DetailLedger5Id &&
              s.DetailLedger6Id === x.DetailLedger6Id &&
              s.DetailLedger7Id === x.DetailLedger7Id
          ).DebitRemain = x.DebitRemain;
        this.model.AccCloseProfitandLossAccountsDetails.find(
          (s) =>
            s.SubLedgerId === x.SubLedgerId &&
            s.DetailLedgerId === x.DetailLedgerId &&
            s.DetailLedger2Id === x.DetailLedger2Id &&
            s.DetailLedger3Id === x.DetailLedger3Id &&
            s.DetailLedger4Id === x.DetailLedger4Id &&
            s.DetailLedger5Id === x.DetailLedger5Id &&
            s.DetailLedger6Id === x.DetailLedger6Id &&
            s.DetailLedger7Id === x.DetailLedger7Id
        ).CreditRemain = x.CreditRemain;
      });
    }
  }
  async setUnSelectAccounts() {
    if (this.isLoading || this.model.AccVoucherHeaderId) return;
    this.isLoading = true;
    if (!this.accountService.authService.currentFiscalYear) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe(async (x) => {
        if (x) {
          if (this.formGroup) this.model.VoucherDate = this.formGroup.controls["VoucherDate"].value;
          const voucherInfo = new VoucherInfo();
          voucherInfo.VoucherDate = this.model.VoucherDate;
          voucherInfo.FiscalYearId = x.Id;
          voucherInfo.Id = this.model.Id;
          voucherInfo.BranchId = this.accountService.authService.currentBranchId;
          this.setValue("BranchId", voucherInfo.BranchId);
          this.setValue("FiscalYearId", voucherInfo.FiscalYearId);
          this.setValue("VoucherDate", voucherInfo.VoucherDate);
          if (!voucherInfo.VoucherDate) return;
          await this.httpCommonService
            .create(`${this.apiName}/GetUnSelectAccounts`, voucherInfo)
            .pipe(takeUntil(this.ngUnsubscribe))
            .toPromise()
            .then(
              (data) => {
                if (data) {
                  this.isLoading = false;
                  this.UnSelectAccounts = data as [];
                  this.getUnSelectAccounts();
                  this.setRemainValue();
                }
                this.cd.markForCheck();
              },
              (error) => {
                this.saveFailedHelper(error);
                this.isLoading = false;
              }
            );
        }
      });
    } else {
      if (this.formGroup) this.model.VoucherDate = this.formGroup.controls["VoucherDate"].value;

      const voucherInfo = new VoucherInfo();
      voucherInfo.VoucherDate = this.model.VoucherDate;
      voucherInfo.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
      voucherInfo.Id = this.model.Id;
      voucherInfo.BranchId = this.accountService.authService.currentBranchId;
      if (!voucherInfo.VoucherDate) return;
      this.setValue("BranchId", voucherInfo.BranchId);
      this.setValue("FiscalYearId", voucherInfo.FiscalYearId);
      this.setValue("VoucherDate", voucherInfo.VoucherDate);
      await this.httpCommonService
        .create(`${this.apiName}/GetUnSelectAccounts`, voucherInfo)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then(
          (data) => {
            if (data) {
              if (this.erroremessage.includes("قطعی نشده")) this.erroremessage = undefined;
              this.isLoading = false;
              this.UnSelectAccounts = data as [];
              this.getUnSelectAccounts();
              this.setRemainValue();
            }
            this.cd.markForCheck();
          },
          (error) => {
            this.erroremessage = `${Utilities.getHttpResponseMessage(error)}`;
            this.saveFailedHelper(error);
            this.isLoading = false;
          }
        );
    }
  }
  onChanged($event) {
    if ($event && typeof $event === "string" && ($event.includes("/") || $event.includes("-")) && !this.isLoading) this.setUnSelectAccounts();
  }
  onRowSelected($event) {
    if ($event && $event.HasDetailLedger1 && this.currentSubLedger?.Id != $event.Id) {
      this.currentSubLedger = $event;
      this.setColumnAttribute();
    }
  }
  setDefaultValues() {
    this.orignalColumns.forEach((x) => {
      if (x.controlType === FormControlTypes.checkbox && this.model[x.name] === undefined) this.model[x.name] = false;
    });
  }

  getDetailControlModels(keyName: string) {
    let columns = this.orignalColumns.find((x) => x.name === keyName).DetailControlModels[keyName];
    columns.forEach((x) => {
      if (x.name.includes("DetailLedger1")) {
        if (!this.groups.some((f) => f.field === "DetailLedger1Title") && this._detailLedgerLevel >= 1)
          this.groups.push({ field: "DetailLedger1Title" });
        x.listVisible = this._detailLedgerLevel >= 1;
        if (x.name.includes("DetailLedgerId")) x.listVisible = false;
      }
      if (x.name.includes("DetailLedger2")) {
        if (!this.groups.some((f) => f.field === "DetailLedger2Title") && this._detailLedgerLevel >= 2)
          this.groups.push({ field: "DetailLedger2Title" });
        x.listVisible = this._detailLedgerLevel >= 2;
        if (x.name.includes("DetailLedger2Id")) x.listVisible = false;
      }
      if (x.name.includes("DetailLedger3")) {
        if (!this.groups.some((f) => f.field === "DetailLedger3Title") && this._detailLedgerLevel >= 3)
          this.groups.push({ field: "DetailLedger3Title" });
        x.listVisible = this._detailLedgerLevel >= 3;
        if (x.name.includes("DetailLedger3Id")) x.listVisible = false;
      }
      if (x.name.includes("DetailLedger4")) {
        if (!this.groups.some((f) => f.field === "DetailLedger4Title") && this._detailLedgerLevel >= 4)
          this.groups.push({ field: "DetailLedger4Title" });
        x.listVisible = this._detailLedgerLevel >= 4;
        if (x.name.includes("DetailLedger4Id")) x.listVisible = false;
      }
      if (x.name.includes("DetailLedger5")) {
        if (!this.groups.some((f) => f.field === "DetailLedger5Title") && this._detailLedgerLevel >= 5)
          this.groups.push({ field: "DetailLedger5Title" });
        x.listVisible = this._detailLedgerLevel >= 5;
        if (x.name.includes("DetailLedger5Id")) x.listVisible = false;
      }
      if (x.name.includes("DetailLedger6")) {
        if (!this.groups.some((f) => f.field === "DetailLedger6Title") && this._detailLedgerLevel >= 6)
          this.groups.push({ field: "DetailLedger6Title" });
        x.listVisible = this._detailLedgerLevel >= 6;
        if (x.name.includes("DetailLedger6Id")) x.listVisible = false;
      }
      if (x.name.includes("DetailLedger7")) {
        if (!this.groups.some((f) => f.field === "DetailLedger7Title") && this._detailLedgerLevel >= 7)
          this.groups.push({ field: "DetailLedger7Title" });
        x.listVisible = this._detailLedgerLevel >= 7;
        if (x.name.includes("DetailLedger7Id")) x.listVisible = false;
      }
    });
    return columns;
  }

  close() {
    this.accountService.authService.getMvcController();
    super.close();
  }
  getUnSelectAccounts() {
    this.setAccCloseProfitandLossAccountsDetails();
    let list = this.AccCloseProfitandLossAccountsDetailsList;
    this._UnSelectAccounts = this.UnSelectAccounts.filter(
      (x) =>
        !list.some(
          (f) =>
            x.SubLedgerId === f.SubLedgerId &&
            x.DetailLedgerId === f.DetailLedgerId &&
            x.DetailLedger2Id === f.DetailLedger2Id &&
            x.DetailLedger3Id === f.DetailLedger3Id &&
            x.DetailLedger4Id === f.DetailLedger4Id &&
            x.DetailLedger5Id === f.DetailLedger5Id &&
            x.DetailLedger6Id === f.DetailLedger6Id &&
            x.DetailLedger7Id === f.DetailLedger7Id
        )
    );
  }
  setAccCloseProfitandLossAccountsDetails() {
    this.model.AccCloseProfitandLossAccountsDetails = this.model.AccCloseProfitandLossAccountsDetails.filter((x) => x.State !== RowState.Detached);
    this.AccCloseProfitandLossAccountsDetailsList = this.model.AccCloseProfitandLossAccountsDetails.filter(
      (x) => x.State !== RowState.Delete && x.State !== RowState.Detached
    );
  }
  onSeletedDoubleClick(event: AccCloseProfitandLossAccountsDetail) {
    if (event.Id > 0) this.model.AccCloseProfitandLossAccountsDetails.find((x) => x.Id === event.Id).State = RowState.Delete;
    else {
      this.model.AccCloseProfitandLossAccountsDetails.find(
        (x) =>
          x.Id === event.Id &&
          x.SubLedgerId === event.SubLedgerId &&
          x.DetailLedgerId === event.DetailLedgerId &&
          x.DetailLedger2Id === event.DetailLedger2Id &&
          x.DetailLedger3Id === event.DetailLedger3Id &&
          x.DetailLedger4Id === event.DetailLedger4Id &&
          x.DetailLedger5Id === event.DetailLedger5Id &&
          x.DetailLedger6Id === event.DetailLedger6Id &&
          x.DetailLedger7Id === event.DetailLedger7Id
      ).State = RowState.Detached;
    }
  }
  onUnSeletedDoubleClick(event: AccCloseProfitandLossAccountsDetail) {
    let entity = Object.assign({}, event);
    entity.State = RowState.New;
    this.model.AccCloseProfitandLossAccountsDetails.push(entity);
  }
  moveLeft() {
    if (this.RowForSelect) {
      let entity = Object.assign({}, this.RowForSelect);
      entity.State = RowState.New;
      this.model.AccCloseProfitandLossAccountsDetails.push(entity);
      this.RowForSelect = undefined;
      this.getUnSelectAccounts();
    }
  }
  moveright() {
    if (this.RowForDelete) {
      if (this.RowForDelete.Id > 0)
        this.model.AccCloseProfitandLossAccountsDetails.find((x) => x.Id === this.RowForDelete.Id).State = RowState.Delete;
      else {
        this.model.AccCloseProfitandLossAccountsDetails.find(
          (x) =>
            x.Id === this.RowForDelete.Id &&
            x.SubLedgerId === this.RowForDelete.SubLedgerId &&
            x.DetailLedgerId === this.RowForDelete.DetailLedgerId &&
            x.DetailLedger2Id === this.RowForDelete.DetailLedger2Id &&
            x.DetailLedger3Id === this.RowForDelete.DetailLedger3Id &&
            x.DetailLedger4Id === this.RowForDelete.DetailLedger4Id &&
            x.DetailLedger5Id === this.RowForDelete.DetailLedger5Id &&
            x.DetailLedger6Id === this.RowForDelete.DetailLedger6Id &&
            x.DetailLedger7Id === this.RowForDelete.DetailLedger7Id
        ).State = RowState.Detached;
      }
      this.RowForDelete = undefined;
      this.getUnSelectAccounts();
    }
  }
  moveLeftAll() {
    this.UnSelectAccounts.forEach((event) => {
      if (
        !this.model.AccCloseProfitandLossAccountsDetails.some(
          (x) =>
            x.Id === event.Id &&
            x.SubLedgerId === event.SubLedgerId &&
            x.DetailLedgerId === event.DetailLedgerId &&
            x.DetailLedger2Id === event.DetailLedger2Id &&
            x.DetailLedger3Id === event.DetailLedger3Id &&
            x.DetailLedger4Id === event.DetailLedger4Id &&
            x.DetailLedger5Id === event.DetailLedger5Id &&
            x.DetailLedger6Id === event.DetailLedger6Id &&
            x.DetailLedger7Id === event.DetailLedger7Id
        )
      ) {
        let entity = Object.assign({}, event);
        entity.State = RowState.New;
        this.model.AccCloseProfitandLossAccountsDetails.push(entity);
      }
    });
    this.getUnSelectAccounts();
  }
  moveRightAll() {
    this.model.AccCloseProfitandLossAccountsDetails.forEach((x) => {
      if (x.Id > 0 && x.State === RowState.NoChange) x.State = RowState.Delete;
      if (x.State === RowState.New) x.State = RowState.Detached;
    });
    this.getUnSelectAccounts();
  }
  onValueChangeByApiName($event) {
    if ($event && $event.apiName && $event.data && $event.data.Id && $event.apiName.includes("SubLedger")) {
    }
  }
  getDetailLedgerParameter(apiName: string, columName: string) {
    let p1: string = "";
    if (!this.formGroup || !this.formGroup.controls["SubLedgerId"] || !this.formGroup.controls["SubLedgerId"].value) return p1;
    if (apiName.includes("DetailLedgerWithSubLedgerId") && columName === "DetailLedgerId") {
      p1 = `/?subLedgerId=${this.formGroup.controls["SubLedgerId"].value}&detailLegerLevel=1`;
    }
    if (apiName.includes("DetailLedgerWithSubLedgerId") && columName === "DetailLedger2Id") {
      p1 = `/?subLedgerId=${this.formGroup.controls["SubLedgerId"].value}&detailLegerLevel=2`;
    }
    if (apiName.includes("DetailLedgerWithSubLedgerId") && columName === "DetailLedger3Id") {
      p1 = `/?subLedgerId=${this.formGroup.controls["SubLedgerId"].value}&detailLegerLevel=3`;
    }
    if (apiName.includes("DetailLedgerWithSubLedgerId") && columName === "DetailLedger4Id") {
      p1 = `/?subLedgerId=${this.formGroup.controls["SubLedgerId"].value}&detailLegerLevel=4`;
    }
    if (apiName.includes("DetailLedgerWithSubLedgerId") && columName === "DetailLedger5Id") {
      p1 = `/?subLedgerId=${this.formGroup.controls["SubLedgerId"].value}&detailLegerLevel=5`;
    }
    if (apiName.includes("DetailLedgerWithSubLedgerId") && columName === "DetailLedger6Id") {
      p1 = `/?subLedgerId=${this.formGroup.controls["SubLedgerId"].value}&detailLegerLevel=6`;
    }
    if (apiName.includes("DetailLedgerWithSubLedgerId") && columName === "DetailLedger7Id") {
      p1 = `/?subLedgerId=${this.formGroup.controls["SubLedgerId"].value}&detailLegerLevel=7`;
    }
    return p1;
  }
  onDataStateChange(columnName: string, searchValue: string, skip: number, take: number): Observable<PagingDataResult<any>> {
    var abs = new BehaviorSubject<PagingDataResult<any>>(null);
    let apiName: string = "DetailLedger/DetailLedgerWithSubLedgerId";
    let p = this.getDetailLedgerParameter(apiName, columnName);
    if (p === undefined) return null;
    if (p) {
      if (this.LookupIsLoading[columnName]) return abs.asObservable();
      let _detailLedgerLevel: number = 1;
      if (columnName === "DetailLedgerId") _detailLedgerLevel = 1;
      if (columnName === "DetailLedger2Id") _detailLedgerLevel = 2;
      if (columnName === "DetailLedger3Id") _detailLedgerLevel = 3;
      if (columnName === "DetailLedger4Id") _detailLedgerLevel = 4;
      if (columnName === "DetailLedger5Id") _detailLedgerLevel = 5;
      if (columnName === "DetailLedger6Id") _detailLedgerLevel = 6;
      if (columnName === "DetailLedger7Id") _detailLedgerLevel = 7;
      this.LookupIsLoading[columnName] = true;
      this.httpCommonService
        .get<PagingDataResult<any>>(apiName + p + `&searchValue=${searchValue}&skip=${skip}&take=${take}`)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then(
          (x) => {
            this.LookupIsLoading[columnName] = false;
            if (x) abs.next(x);
          },
          (err) => {
            this.LookupIsLoading[columnName] = false;
            this.saveFailedHelper(err);
          }
        );
    }
    return abs.asObservable();
  }
  isValid() {
    let flag: boolean = true;
    this.erroremessage = undefined;
    if (!this.formGroup.controls["FiscalYearId"].value) {
      if (!this.formGroup.controls["FiscalYearId"].value && !this.accountService.authService.currentFiscalYear) {
        this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
          if (x) this.setValue("FiscalYearId", x.Id);
        });
        this.erroremessage = `سال مالی انتخاب نشده است.`;
        flag = false;
      } else if (this.accountService.authService.currentFiscalYear)
        this.setValue("FiscalYearId", this.accountService.authService.currentFiscalYear.Id);
      return flag;
    }
    return flag;
  }
  beforupdate() {
    if (this.model.AccCloseProfitandLossAccountsDetails && this.model.AccCloseProfitandLossAccountsDetails.length > 0) {
      if (!this.formGroup.controls["AccCloseProfitandLossAccountsDetails"])
        this.formGroup.addControl("AccCloseProfitandLossAccountsDetails", new UntypedFormControl(this.model.AccCloseProfitandLossAccountsDetails));
      else this.formGroup.controls["AccCloseProfitandLossAccountsDetails"].setValue(this.model.AccCloseProfitandLossAccountsDetails);
      this.formGroup.updateValueAndValidity();
    } else this.erroremessage = "برای سند هیچ قلمی وارد نشده است.";
  }
  shouldBeChangedData(columnName: string): boolean {
    return this.formGroup?.controls["SubLedgerId"]?.value !== undefined && this.formGroup?.controls["SubLedgerId"]?.value !== this.PrevSubLedgerId;
  }
  async setAccVoucherKind() {
    await this.httpCommonService
      .get("AccVoucherKind/ReadAccVoucherKindLookUp")
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data: AccVoucherKind[]) => {
          let vk = data.filter((x) => x.Code === 3 || !x.IsOperating);
          this.selectorService.setDataList("AccVoucherKindId", vk);
        },
        (error) => {}
      );
  }
  async newVoucher() {
    if (!this.model.AccVoucherHeaderId) {
      this.splashFormService.openDialog("", "در حال صدور سند حسابداری");
      this.beforupdate();
      this.model = super.getDataFromFormGroup();
      this.model.AccCloseProfitandLossAccountsDetails.forEach((x) => {
        x.TotalCredit = x.CreditRemain;
        x.TotalDebit = x.DebitRemain;
      });
      await this.httpCommonService
        .create(this.apiName + "/CreatAccVoucher", this.model)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then(
          (row) => {
            this.splashFormService.closeLoading();
            this.sts.showDialog("سند با موفقیت صادر شد.", "");
            this.saveSuccessHelper(row);
            this.ngOnInit();
          },
          (error) => {
            this.splashFormService.closeLoading();
            this.sts.showDialog(`خطا در صدور سند ${Utilities.getHttpResponseMessage(error)}`, "خطا");
          }
        );
    }
  }
  async deletVoucher() {
    if (this.model.AccVoucherHeaderId) {
      this.splashFormService.openDialog("", "در حال حذف سند حسابداری");
      await this.httpCommonService
        .create(this.apiName.split("/")[0] + "/DeleteAccVoucher", this.model)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then(
          (row) => {
            this.saveSuccessHelper(row);
            this.splashFormService.closeLoading();
            this.sts.showDialog("سند با موفقیت حذف شد.", "");
            this.ngOnInit();
          },
          (error) => {
            this.splashFormService.closeLoading();
            this.sts.showDialog(`خطا در حذف اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا");
          }
        );
    } else this.erroremessage = "سند حسابداری وجود ندارد.";
  }
  isCloseable() {
    return false;
  }
}
